var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOmis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 24,
    viewBox: "0 0 92 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OMNI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98254 24C4.08479 24 3.25436 23.7778 2.49127 23.3333C1.72818 22.8889 1.12219 22.2889 0.673316 21.5333C0.224439 20.7778 0 19.9556 0 19.0667V4.93333C0 4.02222 0.224439 3.2 0.673316 2.46667C1.12219 1.71111 1.72818 1.11111 2.49127 0.666666C3.25436 0.222222 4.08479 0 4.98254 0H19.2568C20.1546 0 20.9738 0.222222 21.7145 0.666666C22.4775 1.11111 23.0835 1.71111 23.5324 2.46667C24.0037 3.2 24.2394 4.02222 24.2394 4.93333V19.0667C24.2394 19.9556 24.0037 20.7778 23.5324 21.5333C23.0835 22.2889 22.4775 22.8889 21.7145 23.3333C20.9738 23.7778 20.1546 24 19.2568 24H4.98254ZM5.2182 18.8H18.9539V5.2H5.2182V18.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9468 24V0H33.3334L41.5478 9.7L49.7286 0H55.1488V24H49.8969V7.9L41.5478 17.7667L33.165 7.93333V24H27.9468Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1798 24V0H64.5663L78.1336 16V0H83.4191V24H78.0326L64.398 7.93333V24H59.1798Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3491 24V0H91.5V24H86.3491Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOmis);
export default __webpack_public_path__ + "static/media/logoOmis.06e7bb7cf65b8f55fdc34c77a1a813d6.svg";
export { ForwardRef as ReactComponent };